export default __webpack_public_path__ + "static/media/sass.00b97465.png";